/** Platform that produced a health sync record. */
export var HealthSyncPlatform;
(function (HealthSyncPlatform) {
    HealthSyncPlatform["APPLE_HEALTH"] = "APPLE_HEALTH";
    HealthSyncPlatform["HEALTH_CONNECT"] = "HEALTH_CONNECT";
    /** Third-party device vendor or integration middleware. */
    HealthSyncPlatform["PARTNER"] = "PARTNER";
})(HealthSyncPlatform || (HealthSyncPlatform = {}));
/** High-level bucket for agent queries and routing. */
export var HealthSyncCategory;
(function (HealthSyncCategory) {
    HealthSyncCategory["CHARACTERISTIC"] = "CHARACTERISTIC";
    HealthSyncCategory["BODY"] = "BODY";
    HealthSyncCategory["VITAL"] = "VITAL";
    HealthSyncCategory["ACTIVITY"] = "ACTIVITY";
    HealthSyncCategory["NUTRITION"] = "NUTRITION";
    HealthSyncCategory["SLEEP"] = "SLEEP";
    HealthSyncCategory["WORKOUT"] = "WORKOUT";
    HealthSyncCategory["OTHER"] = "OTHER";
})(HealthSyncCategory || (HealthSyncCategory = {}));
